var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M8 4c1.545 0 2.93.702 3.85 1.813l.12.154h.056l.12-.153A4.99 4.99 0 0 1 16 4h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2.96c-.977 0-1.933.29-2.747.832l-.455.303a5.151 5.151 0 0 1-5.714 0l-.454-.303A4.954 4.954 0 0 0 5.922 20H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5zm0 2H4v12h1.922c1.373 0 2.715.406 3.857 1.168l.454.303c.194.13.401.236.617.319l.15.051V9.025l-.004-.176A3 3 0 0 0 8 6zm12 0h-4a3 3 0 0 0-3 3v10.828l.113-.038a3.15 3.15 0 0 0 .616-.32l.454-.302A6.954 6.954 0 0 1 18.041 18H20V6z" })
  );
});